<template>
<div class="chapter">
<div class="inner_page">
<p class="centert" id="also"><a id="page_i"></a><a id="page_ii"></a>Also by Frances Hardinge</p>
<p class="center"><em>Cuckoo Song</em></p>
<p class="center"><em>The Lie Tree</em></p>
<p class="center"><em>A Face Like Glass</em></p>
<p class="center"><em>Fly By Night</em></p>
<p class="center"><em>Fly Trap</em></p>
<p class="center"><em>A Skinful of Shadows</em></p>
<div class="pagebreak">
<p class="image"><a id="page_iii"></a><img alt="Images" src="images/f0iii-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?30c745b8